import MentionFormat from './MentionFormat';
import TagMention from '../TagMention';
export default class HashMentionFormat extends MentionFormat {
  mentionables = (() => [TagMention])();
  extendable = true;
  trigger() {
    return '#';
  }
  queryFromTyped(typed) {
    const matchTyped = typed.match(/^[-_\p{L}\p{N}\p{M}]+$/giu);
    return matchTyped ? matchTyped[0] : null;
  }
  format(slug) {
    return `#${slug}`;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/formats/HashMentionFormat', HashMentionFormat);